const filterCampaignPropertiesByDestination = (
  featuredProperties,
  destinationName,
) => {
  return destinationName
    ? featuredProperties.filter(
        ({ propertyContent }) =>
          propertyContent.destination.name === destinationName,
      )
    : featuredProperties;
};

export default filterCampaignPropertiesByDestination;
